import React, { useState } from "react";
import "../styles/Footer.css";

const Footer = ({ scrollToSection }) => {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");

  const handleNewsletterSignup = (e) => {
    e.preventDefault();
    // TODO: Implement newsletter signup
    console.log("Newsletter signup:", email);
    alert("Thank you for subscribing to the Adventure Newsletter!");
    setEmail("");
  };

  return (
    <footer className="footer-container">
      <div className="footer-main">
        {/* Newsletter Section */}
        <div className="footer-newsletter">
          <h2 className="footer-newsletter-title">
            Join the <span className="title-italic">Adventure</span> Newsletter
          </h2>
          <p className="footer-newsletter-description">
            Get exclusive stories, photography tips, and travel updates delivered to your inbox.
          </p>
          <form className="footer-newsletter-form" onSubmit={handleNewsletterSignup}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="footer-newsletter-input"
            />
            <button type="submit" className="footer-newsletter-button">
              Sign Up
            </button>
          </form>
        </div>

        {/* Footer Grid */}
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <h3 className="footer-logo">HAMIDREZA</h3>
            <p className="footer-tagline">Nature Explorer & Visual Storyteller</p>
            <p className="footer-description">
              Documenting raw adventures across the globe, one journey at a time.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-nav">
              <li onClick={() => scrollToSection('home')}>Home</li>
              <li onClick={() => scrollToSection('about')}>About Me</li>
              <li onClick={() => scrollToSection('gallery')}>Projects</li>
              <li onClick={() => scrollToSection('contact')}>Contact</li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="footer-social">
            <h4 className="footer-heading">Follow</h4>
            <ul className="footer-nav">
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
              <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer">YouTube</a></li>
              {/* <li><a href="#" target="_blank" rel="noopener noreferrer">Website</a></li> */}
            </ul>
          </div>

          {/* Connect */}
          <div className="footer-connect">
            <h4 className="footer-heading">Connect</h4>
            <ul className="footer-nav">
              <li onClick={() => scrollToSection('contact')}>Get in touch</li>
              <li><a href="https://patreon.com" target="_blank" rel="noopener noreferrer">Patreon</a></li>
              <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer">My channels</a></li>
              <li onClick={() => scrollToSection('contact')}>Work with me</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-bottom">
        <p>&copy; {currentYear} Hamidreza. All rights reserved.</p>
        <p className="footer-credits">Designed & Developed by Aleikoom</p>
      </div>
    </footer>
  );
};

export default Footer;
